export default "__VITE_ASSET__ec6c64db__"